import { Drawer, type DrawerProps, Grid, Spin, Typography, theme } from "antd";
import { useState } from "react";

type CustomDrawerProps = DrawerProps & {
	children: React.ReactNode;
	/** When set, covers the drawer body with a full-page spinner + this message (not the antd skeleton). */
	loadingMessage?: React.ReactNode;
};

export function CustomDrawer({
	children,
	size = "default",
	loadingMessage,
	...props
}: CustomDrawerProps) {
	const screens = Grid.useBreakpoint();
	const isMobile = !screens.md;
	const {
		token: { borderRadius, colorBgContainer },
	} = theme.useToken();
	const [currentSize, setCurrentSize] = useState(size);

	return (
		<Drawer
			{...props}
			resizable={{
				onResize: (newSize) => setCurrentSize(newSize),
			}}
			title={
				<Typography.Text
					strong
					ellipsis={{ tooltip: props.title }}
					style={{ maxWidth: 150 }}
				>
					{props.title}
				</Typography.Text>
			}
			size={currentSize}
			placement={isMobile ? "bottom" : "right"}
			rootStyle={{
				pointerEvents: "none",
				...props.rootStyle,
			}}
			style={{ borderRadius, ...props.style }}
			styles={{
				wrapper: {
					pointerEvents: "auto",
					right: isMobile ? 8 : 16,
					left: isMobile ? 8 : undefined,
					top: isMobile ? undefined : 16,
					bottom: isMobile ? 8 : 16,
					maxHeight: isMobile ? "90%" : undefined,
					// merge caller's wrapper overrides if any
					//@ts-expect-error no types available
					...props.styles?.wrapper,
				},
				// Positioning context for the full-page loading overlay.
				body: {
					position: "relative",
					//@ts-expect-error no types available
					...props.styles?.body,
				},
			}}
		>
			{loadingMessage && (
				<div
					style={{
						position: "absolute",
						inset: 0,
						zIndex: 10,
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						justifyContent: "center",
						gap: 16,
						background: colorBgContainer,
					}}
				>
					<Spin size="large" />
					<Typography.Text type="secondary">{loadingMessage}</Typography.Text>
				</div>
			)}
			{children}
		</Drawer>
	);
}
